import { render, staticRenderFns } from "./html-template-button.vue?vue&type=template&id=2ef4a128&scoped=true&"
import script from "./html-template-button.vue?vue&type=script&lang=ts&"
export * from "./html-template-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4a128",
  null
  
)

export default component.exports